module.exports = __webpack_public_path__ + "static/media/imageCroppingLittle.3dedd1eb.svg";